import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { GhostParagraphModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-paragraph';
import { GhostTitleModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-title';

@Component({
  selector: 'x-ghost-section-one',
  standalone: true,
  imports: [GhostTitleModule, GhostParagraphModule],
  templateUrl: './ghost-section-one.component.html',
  styleUrl: './ghost-section-one.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-ghost-section-one' },
})
export class GhostSectionOneComponent {
  @HostBinding('style.height.px')
  @Input()
  height = 150;
}
